"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColumnIdContextProvider: function() {
        return ColumnIdContextProvider;
    },
    columnIdContextDefaultValue: function() {
        return columnIdContextDefaultValue;
    },
    useColumnIdContext: function() {
        return useColumnIdContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const columnIdContext = /*#__PURE__*/ _react.createContext(undefined);
const columnIdContextDefaultValue = '';
const useColumnIdContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(columnIdContext)) !== null && _React_useContext !== void 0 ? _React_useContext : columnIdContextDefaultValue;
};
const ColumnIdContextProvider = columnIdContext.Provider;
